// https://stackoverflow.com/questions/69000971/how-to-use-i18n-in-the-vuex-store

import Vue from "vue";
import VueI18n from "vue-i18n";

import ptBR_buttons from "./pt-br/buttons.json";
import ptBR_commons from "./pt-br/commons.json";
import ptBR_components from "./pt-br/components.json";
import ptBR_messages from "./pt-br/messages.json";
import ptBR_modals from "./pt-br/modals.json";
import ptBR_pages from "./pt-br/pages.json";
import ptBR_server from "./pt-br/server.json";

import enUS_buttons from "./en-us/buttons.json";
import enUS_commons from "./en-us/commons.json";
import enUS_components from "./en-us/components.json";
import enUS_messages from "./en-us/messages.json";
import enUS_modals from "./en-us/modals.json";
import enUS_pages from "./en-us/pages.json";
import enUS_server from "./en-us/server.json";

import es_buttons from "./es/buttons.json";
import es_commons from "./es/commons.json";
import es_components from "./es/components.json";
import es_messages from "./es/messages.json";
import es_modals from "./es/modals.json";
import es_pages from "./es/pages.json";
import es_server from "./es/server.json";

Vue.use(VueI18n);

const messages = {
	"pt-BR": {
		buttons: ptBR_buttons,
		commons: ptBR_commons,
		components: ptBR_components,
		messages: ptBR_messages,
		modals: ptBR_modals,
		pages: ptBR_pages,
		server: ptBR_server
	},
	"en-US": {
		buttons: enUS_buttons,
		commons: enUS_commons,
		components: enUS_components,
		messages: enUS_messages,
		modals: enUS_modals,
		pages: enUS_pages,
		server: enUS_server
	},
	es: {
		buttons: es_buttons,
		commons: es_commons,
		components: es_components,
		messages: es_messages,
		modals: es_modals,
		pages: es_pages,
		server: es_server
	}
};

const lang = localStorage.getItem("k4-language") ?? "pt-BR";

const i18n = new VueI18n({
	locale: lang,
	messages
});

export default i18n;
